import React, { useState, useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, message } from 'antd';
import { useDispatch } from 'react-redux';
import { setOrigin, setAdmin, setAuth } from './redux/actions/common'
import * as Service from './core/Service';
import AppRoute from './AppRoute';
// import * as Service from './core/Service';

// import { DataStoreWorker, getSelectionsSetting} from './network/DataStore';

import debugLib from 'debug';

message.config({
  top: '75%',
  maxCount: 1,
});

let configOrigin = '';

const AppContainer = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const init = async () => {
      setLoading(true);

      debugLib.disable();
      let originObj = await Service.call('get', '/api/config');
      if (originObj) {
        configOrigin = originObj.ORIGIN;
      }
      dispatch(setOrigin(configOrigin));


      let resp = await Service.call('get', `/api/admin`);
      if (resp && resp.status > 0) {
        dispatch(setAdmin(resp.userData[0]));
        dispatch(setAuth(true));

        setLoading(false);
        return;
      }

      dispatch(setAuth(false));
      setLoading(false);
    }
    init();
  }, [dispatch])

  if (loading) {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    return (
      <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
        <Spin indicator={antIcon} />
      </div>
    );
  }

  return (
    <div>
      <AppRoute />
    </div>
  );
}

export default AppContainer;